<template>
	<div class="dashboard-container">
		<!-- 顶部标题栏 -->
		<div class="dashboard-header ">
			<div class="header-left">
				<el-button type="primary" icon="el-icon-back" @click="goBack" class="back-button">
					返回
				</el-button>
			</div>
			<h1>公寓智能数据驾驶舱</h1>
			<div class="header-right">
				<span class="current-time">{{ currentTime }}</span>
			</div>
		</div>

		<!-- 项目基本信息 -->
		<div class="project-info border-glow">
			<div class="info-item">
				<span class="info-label">项目名称:</span>
				<span class="info-value">双涵公寓</span>
			</div>
			<div class="info-item">
				<span class="info-label">地址:</span>
				<span class="info-value">社区</span>
			</div>
			<div class="info-item">
				<span class="info-label">建筑面积:</span>
				<span class="info-value">2770㎡</span>
			</div>
			<div class="info-item">
				<span class="info-label">楼栋数量:</span>
				<span class="info-value">9栋</span>
			</div>
			<div class="info-item">
				<span class="info-label">投资金额:</span>
				<span class="info-value">9,000万元</span>
			</div>
			<div class="info-item">
				<span class="info-label">绿化率:</span>
				<span class="info-value">50,000㎡</span>
			</div>
		</div>

		<!-- 内容区域 -->
		<div class="dashboard-content">
			<!-- 左侧：数据分析 -->
			<div class="data-analysis  delay-0">
				<h3 class="module-title">
					<i class="el-icon-data-line"></i>
					数据分析
					<span class="more">更多</span>
				</h3>
				<div class="analysis-cards">
					<div class="analysis-card border-glow">
						<div class="analysis-value">72.20%</div>
						<div class="analysis-label">入住率</div>
						<div class="analysis-total">2000户</div>
					</div>
					<div class="analysis-card border-glow">
						<div class="analysis-value">16.24%</div>
						<div class="analysis-label">交易量</div>
						<div class="analysis-total">2000户</div>
					</div>
					<div class="analysis-card border-glow">
						<div class="analysis-value">3.40%</div>
						<div class="analysis-label">集中率</div>
						<div class="analysis-total">2000户</div>
					</div>
				</div>

				<!-- 用户分析 -->
				<div class="user-analysis">
					<h4 class="section-title">用户分析</h4>
					<div class="user-stats">
						<div class="stat-item border-glow">
							<span class="stat-value">2,845</span>
							<span class="stat-label">累计用户</span>
						</div>
						<div class="stat-item border-glow">
							<span class="stat-value">5.50</span>
							<span class="stat-label">在线用户</span>
						</div>
						<div class="stat-item border-glow">
							<span class="stat-value">58</span>
							<span class="stat-label">今日新增</span>
						</div>
					</div>
					<div class="user-list border-glow">
						<div class="list-header">
							<span>新增客户</span>
							<span>更多</span>
						</div>
						<div class="user-item" v-for="user in newUsers" :key="user.id">
							<div class="user-info">
								<span class="user-name">{{ user.name }}</span>
								<span class="user-room">{{ user.room }}</span>
							</div>
							<span class="user-time">{{ user.time }}</span>
						</div>
					</div>
					<div class="user-rank border-glow">
						<div class="list-header">
							<span>机构用户排名</span>
						</div>
						<div class="rank-item" v-for="(item, index) in rankList" :key="index">
							<div class="rank-number">{{ index + 1 }}</div>
							<div class="rank-info">
								<span class="rank-name">{{ item.name }}</span>
								<span class="rank-level">{{ item.level }}</span>
							</div>
							<span class="rank-value">{{ item.value }}</span>
						</div>
					</div>
				</div>
			</div>

			<!-- 中间：3D可视化区域 -->
			<div class="three-dimensional border-glow delay-1">
				<div ref="threeContainer" class="three-container"></div>
				<div class="building-info">
					<h3>模楼情况</h3>
					<div class="building-stats">
						<div class="stat-item">
							<span class="stat-label">总户数:</span>
							<span class="stat-value">112户</span>
						</div>
						<div class="stat-item">
							<span class="stat-label">入住率:</span>
							<span class="stat-value">89.29%</span>
						</div>
						<div class="stat-item">
							<span class="stat-label">预计下次空房时间:</span>
							<span class="stat-value">2023-05-15</span>
						</div>
					</div>
				</div>
			</div>

			<!-- 右侧：运营数据 -->
			<div class="operation-data delay-2">
				<!-- 入住管理 -->
				<div class="operation-card border-glow">
					<h3 class="module-title">
						<i class="el-icon-user"></i>
						入住管理
						<span class="more">更多</span>
					</h3>
					<div class="chart-container" ref="occupancyChart"></div>
				</div>

				<!-- 资产数据 -->
				<div class="assets-data ">
					<div class="asset-item border-glow">
						<i class="el-icon-office-building"></i>
						<span class="asset-label">空置</span>
						<span class="asset-value">385个</span>
					</div>
					<div class="asset-item border-glow">
						<i class="el-icon-home"></i>
						<span class="asset-label">已售</span>
						<span class="asset-value">25个</span>
					</div>
					<div class="asset-item border-glow">
						<i class="el-icon-setting"></i>
						<span class="asset-label">维修中</span>
						<span class="asset-value">128个</span>
					</div>
					<div class="asset-item border-glow">
						<i class="el-icon-box"></i>
						<span class="asset-label">待租</span>
						<span class="asset-value">235个</span>
					</div>
					<div class="asset-item border-glow">
						<i class="el-icon-user-solid"></i>
						<span class="asset-label">租客</span>
						<span class="asset-value">45个</span>
					</div>
					<div class="asset-item border-glow">
						<i class="el-icon-coin"></i>
						<span class="asset-label">经纪人</span>
						<span class="asset-value">125个</span>
					</div>
				</div>
			</div>

			<!-- 底部：核心数据 -->
			<div class="core-data">
				<!-- 资产统计 -->
				<div class="core-card border-glow delay-3">
					<h3 class="module-title">
						<i class="el-icon-s-data"></i>
						资产统计
						<span class="more">更多</span>
					</h3>
					<div class="asset-stats">
						<div class="stat-item border-glow">
							<span class="stat-value">3,500</span>
							<span class="stat-label">资产规模</span>
						</div>
						<div class="stat-item border-glow">
							<span class="stat-value">3,500</span>
							<span class="stat-label">江东集团</span>
						</div>
						<div class="stat-item border-glow">
							<span class="stat-value">0</span>
							<span class="stat-label">60分钟</span>
						</div>
					</div>
					<div class="asset-details">
						<div class="detail-item">
							<span class="detail-label">01 资产规模</span>
							<div class="detail-bar">
								<div class="bar-fill" style="width: 80%"></div>
							</div>
						</div>
						<div class="detail-item">
							<span class="detail-label">02 融资规模</span>
							<div class="detail-bar">
								<div class="bar-fill" style="width: 65%"></div>
							</div>
						</div>
						<div class="detail-item">
							<span class="detail-label">03 利润</span>
							<div class="detail-bar">
								<div class="bar-fill" style="width: 55%"></div>
							</div>
						</div>
						<div class="detail-item">
							<span class="detail-label">04 现金流</span>
							<div class="detail-bar">
								<div class="bar-fill" style="width: 45%"></div>
							</div>
						</div>
					</div>
					<div class="smart-devices">
						<h4 class="section-title">智能设备</h4>
						<div class="device-item">
							<span class="device-name">智能门锁</span>
							<span class="device-total">215台</span>
							<span class="device-normal">正常: 200台</span>
							<span class="device-alarm">故障: 15台</span>
						</div>
						<div class="device-item">
							<span class="device-name">智能电表</span>
							<span class="device-total">300台</span>
							<span class="device-normal">正常: 290台</span>
							<span class="device-alarm">故障: 10台</span>
						</div>
						<div class="device-item">
							<span class="device-name">智能水表</span>
							<span class="device-total">200台</span>
							<span class="device-normal">正常: 195台</span>
							<span class="device-alarm">故障: 5台</span>
						</div>
						<div class="device-item">
							<span class="device-name">智能摄像头</span>
							<span class="device-total">400台</span>
							<span class="device-normal">正常: 390台</span>
							<span class="device-alarm">故障: 10台</span>
						</div>
					</div>
				</div>

				<!-- 合同管理 -->
				<div class="core-card border-glow delay-4">
					<h3 class="module-title">
						<i class="el-icon-document"></i>
						合同管理
						<span class="more">更多</span>
					</h3>
					<div class="contract-stats">
						<div class="contract-item">
							<div class="contract-icon pending"></div>
							<span class="contract-label">待签数量</span>
							<span class="contract-value">20</span>
						</div>
						<div class="contract-item">
							<div class="contract-icon processing"></div>
							<span class="contract-label">处理数量</span>
							<span class="contract-value">24</span>
						</div>
						<div class="contract-item">
							<div class="contract-icon due"></div>
							<span class="contract-label">到期数量</span>
							<span class="contract-value">2</span>
						</div>
						<div class="contract-item">
							<div class="contract-icon expired"></div>
							<span class="contract-label">逾期数量</span>
							<span class="contract-value">10</span>
						</div>
					</div>
				</div>

				<!-- 财务管理 -->
				<div class="core-card border-glow delay-5">
					<h3 class="module-title">
						<i class="el-icon-money"></i>
						财务管理
					</h3>
					<div class="finance-types">
						<div class="type-item">
							<span class="type-name">类型</span>
							<span class="type-value">数量(户)</span>
							<span class="type-value">收入</span>
							<span class="type-value">待收(元)</span>
						</div>
						<div class="type-item">
							<span class="type-name">租金</span>
							<span class="type-value">2008.00</span>
							<span class="type-value">300.00</span>
							<span class="type-value">0.00</span>
						</div>
						<div class="type-item">
							<span class="type-name">水电费</span>
							<span class="type-value">1,000.00</span>
							<span class="type-value">1,000.00</span>
							<span class="type-value">0.00</span>
						</div>
						<div class="type-item">
							<span class="type-name">综合</span>
							<span class="type-value">2,400.00</span>
							<span class="type-value">2,000.00</span>
							<span class="type-value">0.00</span>
						</div>
					</div>
					<div class="finance-receipts">
						<div class="list-header">
							<span>应收明细</span>
						</div>
						<div class="receipt-item" v-for="receipt in receiptList" :key="receipt.id">
							<span class="receipt-name">{{ receipt.name }}</span>
							<span class="receipt-room">{{ receipt.room }}</span>
							<span class="receipt-amount">{{ receipt.amount }}</span>
							<span class="receipt-time">{{ receipt.time }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { index_data, contract_endtime } from '../../api/api.js'
export default {
	data () {
		return {
			// 当前时间
			currentTime: '',

			// 新增客户列表
			newUsers: [
				{ id: 1, name: '张三', room: '238房 - 武汉', time: '01-23 15:20' },
				{ id: 2, name: '李四', room: '239房 - 北京', time: '01-23 16:20' },
				{ id: 3, name: '王五', room: '240房 - 广州', time: '01-23 17:20' },
				{ id: 4, name: '赵六', room: '241房 - 杭州', time: '01-23 18:20' }
			],

			// 机构用户排名
			rankList: [
				{ name: 'AAA公司', level: 'A+级', value: '200' },
				{ name: 'BBB公司', level: 'A级', value: '150' },
				{ name: 'CCC公司', level: 'B级', value: '100' }
			],

			// 应收明细
			receiptList: [
				{ id: 1, name: '张三', room: '2000元/月', amount: '1.2-15', time: '16:20' },
				{ id: 2, name: '李四', room: '1800元/月', amount: '1.2-15', time: '16:20' },
				{ id: 3, name: '王五', room: '1500元/月', amount: '1.2-15', time: '16:20' },
				{ id: 4, name: '赵六', room: '1200元/月', amount: '1.2-15', time: '16:20' },
				{ id: 5, name: '钱七', room: '1000元/月', amount: '1.2-15', time: '16:20' }
			],

			// 图表实例
			occupancyChart: null,

			// Three.js 相关属性
			threeScene: null,
			threeCamera: null,
			threeRenderer: null,
			threeControls: null,
			threeAnimationId: null
		}
	},

	methods: {
		// 返回上一个页面
		goBack () {
			this.$router.go(-1);
		},

		// 更新当前时间
		updateCurrentTime () {
			const now = new Date();
			const year = now.getFullYear();
			const month = String(now.getMonth() + 1).padStart(2, '0');
			const day = String(now.getDate()).padStart(2, '0');
			const hours = String(now.getHours()).padStart(2, '0');
			const minutes = String(now.getMinutes()).padStart(2, '0');
			const seconds = String(now.getSeconds()).padStart(2, '0');
			const weekday = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][now.getDay()];
			this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${weekday}`;
		},

		// 设置单元格样式
		cellStyle () {
			return 'color: #FFF !important;background: #00203F !important;'
		},

		// 初始化数据
		initData () {
			// 获取首页数据
			index_data().then(res => {
				if (res.status == 200) {
					this.updateMetrics(res.data);
					this.updateChartData(res.data);
					this.initCharts();
				}
			})

			// 获取合同到期数据
			contract_endtime().then(res => {
				this.contractList = res.data;
			})
		},

		// 更新指标卡片
		updateMetrics (data) {
			this.metricCards = [
				{
					title: '近七天新增报修',
					value: data.row1.repair7.add,
					desc: `总报修数: ${data.row1.repair7.total}`
				},
				{
					title: '近七天新增用户',
					value: data.row1.user7.add,
					desc: `总用户数: ${data.row1.user7.total}`
				},
				{
					title: '近七天房租账单',
					value: data.row1.bill7.add,
					desc: `总账单数: ${data.row1.bill7.total}`
				},
				{
					title: '近七天总账单',
					value: data.row1.bill7t.add,
					desc: `总金额: ${data.row1.bill7t.total}`
				},
				{
					title: '未处理报修',
					value: data.row1.repair.no,
					desc: `待处理`
				},
				{
					title: '逾期订单',
					value: data.row1.bill.overdue,
					desc: `需处理`
				}
			];
		},

		// 更新图表数据
		updateChartData (data) {
			this.chartData.trend = {
				days: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'],
				repair: data.row2.repair_add,
				user: data.row2.user,
				bill: data.row2.rent_bill,
				amount: data.row2.money
			};
		},

		// 初始化所有图表
		initCharts () {
			this.initTrendChart();
			this.initHouseChart();
			this.initOrderChart();
		},

		// 初始化趋势图
		initTrendChart () {
			this.trendChart = echarts.init(this.$refs.trendChart);
			const option = {
				backgroundColor: 'transparent',
				tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(0, 30, 60, 0.8)',
					borderRadius: 6,
					borderColor: '#1890ff',
					textStyle: {
						color: '#fff'
					}
				},
				legend: {
					data: ['新增报修', '新增用户', '房租订单', '总金额(千)'],
					top: 0,
					textStyle: {
						color: '#fff'
					}
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: this.chartData.trend.days,
					axisLine: {
						lineStyle: {
							color: '#1890ff'
						}
					},
					axisLabel: {
						color: '#fff'
					}
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#1890ff'
						}
					},
					splitLine: {
						lineStyle: {
							color: 'rgba(24, 144, 255, 0.2)'
						}
					},
					axisLabel: {
						color: '#fff'
					}
				},
				series: [
					{
						name: '新增报修',
						type: 'line',
						data: this.chartData.trend.repair,
						lineStyle: {
							color: '#00ffff'
						},
						symbol: 'circle',
						symbolSize: 8
					},
					{
						name: '新增用户',
						type: 'line',
						data: this.chartData.trend.user,
						lineStyle: {
							color: '#7b68ee'
						},
						symbol: 'circle',
						symbolSize: 8
					},
					{
						name: '房租订单',
						type: 'line',
						data: this.chartData.trend.bill,
						lineStyle: {
							color: '#ffa500'
						},
						symbol: 'circle',
						symbolSize: 8
					},
					{
						name: '总金额(千)',
						type: 'line',
						data: this.chartData.trend.amount,
						lineStyle: {
							color: '#ff6347'
						},
						symbol: 'circle',
						symbolSize: 8
					}
				]
			};
			this.trendChart.setOption(option);
		},

		// 初始化房源状态分布饼图
		initHouseChart () {
			this.houseChart = echarts.init(this.$refs.houseChart);
			// 模拟房源数据，实际应从接口获取
			const houseData = [
				{ value: 120, name: '已出租', itemStyle: { color: '#00ffff' } },
				{ value: 80, name: '未出租', itemStyle: { color: '#7b68ee' } },
				{ value: 20, name: '维修中', itemStyle: { color: '#ffa500' } }
			];
			const option = {
				backgroundColor: 'transparent',
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)',
					backgroundColor: 'rgba(0, 30, 60, 0.8)',
					borderRadius: 6,
					borderColor: '#1890ff',
					textStyle: {
						color: '#fff'
					}
				},
				legend: {
					orient: 'vertical',
					left: 10,
					textStyle: {
						color: '#fff'
					}
				},
				series: [
					{
						name: '房源状态',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: 'rgba(0, 30, 60, 0.8)',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center',
							color: '#fff'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold',
								color: '#fff'
							}
						},
						labelLine: {
							show: false
						},
						data: houseData
					}
				]
			};
			this.houseChart.setOption(option);
		},

		// 初始化订单状态分布柱状图
		initOrderChart () {
			this.orderChart = echarts.init(this.$refs.orderChart);
			// 模拟订单数据，实际应从接口获取
			const orderData = [
				{ value: 350, name: '已完成' },
				{ value: 120, name: '处理中' },
				{ value: 50, name: '逾期' },
				{ value: 80, name: '待支付' }
			];
			const option = {
				backgroundColor: 'transparent',
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					backgroundColor: 'rgba(0, 30, 60, 0.8)',
					borderRadius: 6,
					borderColor: '#1890ff',
					textStyle: {
						color: '#fff'
					}
				},
				xAxis: {
					type: 'category',
					data: orderData.map(item => item.name),
					axisLine: {
						lineStyle: {
							color: '#1890ff'
						}
					},
					axisLabel: {
						color: '#fff'
					}
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#1890ff'
						}
					},
					splitLine: {
						lineStyle: {
							color: 'rgba(24, 144, 255, 0.2)'
						}
					},
					axisLabel: {
						color: '#fff'
					}
				},
				series: [
					{
						name: '订单数量',
						type: 'bar',
						data: orderData.map(item => item.value),
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#1890ff' },
								{ offset: 1, color: '#00bfff' }
							]),
							borderRadius: [4, 4, 0, 0]
						}
					}
				]
			};
			this.orderChart.setOption(option);
		},

		// 窗口大小变化时调整图表
		resizeCharts () {
			if (this.occupancyChart) this.occupancyChart.resize();
			// 调整Three.js渲染器大小
			if (this.threeRenderer) {
				this.threeRenderer.setSize(this.$refs.threeContainer.clientWidth, this.$refs.threeContainer.clientHeight);
			}
		},

		// 初始化Three.js场景
		initThreeScene () {
			// 创建场景
			this.threeScene = new THREE.Scene();
			this.threeScene.background = new THREE.Color(0x001529);

			// 创建相机
			this.threeCamera = new THREE.PerspectiveCamera(
				75,
				this.$refs.threeContainer.clientWidth / this.$refs.threeContainer.clientHeight,
				0.1,
				1000
			);
			this.threeCamera.position.set(10, 10, 10);
			this.threeCamera.lookAt(0, 0, 0);

			// 创建渲染器
			this.threeRenderer = new THREE.WebGLRenderer({ antialias: true });
			this.threeRenderer.setSize(this.$refs.threeContainer.clientWidth, this.$refs.threeContainer.clientHeight);
			this.threeRenderer.setPixelRatio(window.devicePixelRatio);
			this.threeRenderer.shadowMap.enabled = true;
			this.threeRenderer.shadowMap.type = THREE.PCFSoftShadowMap;
			this.$refs.threeContainer.appendChild(this.threeRenderer.domElement);

			// 添加轨道控制器
			this.threeControls = new OrbitControls(this.threeCamera, this.threeRenderer.domElement);
			this.threeControls.enableDamping = true;
			this.threeControls.dampingFactor = 0.05;
			this.threeControls.screenSpacePanning = false;
			this.threeControls.minDistance = 5;
			this.threeControls.maxDistance = 50;
			this.threeControls.maxPolarAngle = Math.PI / 2;

			// 添加光源
			this.addLights();

			// 添加3D模型（公寓建筑）
			this.addApartmentModel();

			// 开始动画循环
			this.animate();
		},

		// 添加光源
		addLights () {
			// 环境光
			const ambientLight = new THREE.AmbientLight(0x404040, 1);
			this.threeScene.add(ambientLight);

			// 方向光（模拟太阳光）
			const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
			directionalLight.position.set(5, 10, 7.5);
			directionalLight.castShadow = true;
			directionalLight.shadow.mapSize.width = 512;
			directionalLight.shadow.mapSize.height = 512;
			directionalLight.shadow.camera.near = 0.5;
			directionalLight.shadow.camera.far = 50;
			this.threeScene.add(directionalLight);

			// 点光源（模拟室内灯光）
			const pointLight1 = new THREE.PointLight(0xffff00, 1, 10);
			pointLight1.position.set(2, 3, 2);
			this.threeScene.add(pointLight1);

			const pointLight2 = new THREE.PointLight(0xffff00, 1, 10);
			pointLight2.position.set(-2, 3, -2);
			this.threeScene.add(pointLight2);
		},

		// 添加公寓模型
		addApartmentModel () {
			// 创建地面
			const floorGeometry = new THREE.PlaneGeometry(20, 20);
			const floorMaterial = new THREE.MeshStandardMaterial({ color: 0x2c3e50 });
			const floor = new THREE.Mesh(floorGeometry, floorMaterial);
			floor.rotation.x = -Math.PI / 2;
			floor.receiveShadow = true;
			this.threeScene.add(floor);

			// 创建公寓建筑（多层结构）
			const buildingWidth = 6;
			const buildingDepth = 6;
			const buildingHeight = 8;
			const floorCount = 4;
			const floorHeight = buildingHeight / floorCount;

			// 建筑主体
			const buildingGeometry = new THREE.BoxGeometry(buildingWidth, buildingHeight, buildingDepth);
			const buildingMaterial = new THREE.MeshStandardMaterial({ color: 0x3498db });
			const building = new THREE.Mesh(buildingGeometry, buildingMaterial);
			building.position.y = buildingHeight / 2;
			building.castShadow = true;
			building.receiveShadow = true;
			this.threeScene.add(building);

			// 添加楼层分隔线
			for (let i = 1; i < floorCount; i++) {
				const floorLineGeometry = new THREE.BoxGeometry(buildingWidth + 0.2, 0.1, buildingDepth + 0.2);
				const floorLineMaterial = new THREE.MeshStandardMaterial({ color: 0x2980b9 });
				const floorLine = new THREE.Mesh(floorLineGeometry, floorLineMaterial);
				floorLine.position.y = i * floorHeight;
				floorLine.castShadow = true;
				this.threeScene.add(floorLine);
			}

			// 添加窗户
			const windowGeometry = new THREE.BoxGeometry(0.6, 0.8, 0.1);
			const windowMaterial = new THREE.MeshStandardMaterial({ color: 0x00ffff, transparent: true, opacity: 0.3 });

			// 窗户位置配置
			const windowPositions = [
				{ x: buildingWidth / 2 + 0.05, z: 0, count: 3 }, // 正面
				{ x: -buildingWidth / 2 - 0.05, z: 0, count: 3 }, // 背面
				{ z: buildingDepth / 2 + 0.05, x: 0, count: 3 }, // 右侧面
				{ z: -buildingDepth / 2 - 0.05, x: 0, count: 3 } // 左侧面
			];

			// 创建立方体窗户阵列
			for (const pos of windowPositions) {
				for (let floor = 0; floor < floorCount; floor++) {
					for (let win = 0; win < pos.count; win++) {
						const windowMesh = new THREE.Mesh(windowGeometry, windowMaterial);

						// 计算窗户位置
						windowMesh.position.y = (floor + 0.5) * floorHeight;
						if (pos.x === 0) {
							// 侧面窗户（沿x轴排列）
							windowMesh.position.x = pos.x + (win - 1) * 1.5;
							windowMesh.position.z = pos.z;
						} else {
							// 正面/背面窗户（沿z轴排列）
							windowMesh.position.x = pos.x;
							windowMesh.position.z = pos.z + (win - 1) * 1.5;
						}

						windowMesh.castShadow = true;
						this.threeScene.add(windowMesh);
					}
				}
			}



		},
		// 动画循环
		animate () {
			this.threeAnimationId = requestAnimationFrame(this.animate);

			// 更新控制器
			this.threeControls.update();

			// 渲染场景
			this.threeRenderer.render(this.threeScene, this.threeCamera);
		},

		// 销毁Three.js场景
		destroyThreeScene () {
			if (this.threeAnimationId) {
				cancelAnimationFrame(this.threeAnimationId);
			}

			if (this.threeControls) {
				this.threeControls.dispose();
			}

			if (this.threeRenderer) {
				this.threeRenderer.dispose();
				if (this.$refs.threeContainer && this.threeRenderer.domElement) {
					this.$refs.threeContainer.removeChild(this.threeRenderer.domElement);
				}
			}

			// 清空场景
			if (this.threeScene) {
				while (this.threeScene.children.length > 0) {
					this.threeScene.remove(this.threeScene.children[0]);
				}
			}
		}
	},

	mounted () {
		// 初始化数据
		this.initData();
		// 初始化时间
		this.updateCurrentTime();
		// 每秒更新时间
		this.timeInterval = setInterval(this.updateCurrentTime, 1000);
		// 监听窗口大小变化
		window.addEventListener('resize', this.resizeCharts);
		// 初始化Three.js场景
		this.$nextTick(() => {
			this.initThreeScene();
		});
	},

	beforeDestroy () {
		// 清除时间定时器
		if (this.timeInterval) clearInterval(this.timeInterval);
		// 移除事件监听
		window.removeEventListener('resize', this.resizeCharts);
		// 销毁图表实例
		if (this.occupancyChart) this.occupancyChart.dispose();
		// 销毁Three.js场景
		this.destroyThreeScene();
	}
}
</script>

<style scoped>
/* 全局样式重置 */
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

/* 主容器样式 */
.dashboard-container {
	width: 100%;
	height: 100vh;
	background-color: #001529;
	background-image: linear-gradient(135deg, #001529 0%, #003a66 100%);
	padding: 15px;
	box-sizing: border-box;
	overflow: hidden;
	font-family: 'Arial', sans-serif;
	display: flex;
	flex-direction: column;
	color: #fff;
}

/* 顶部标题栏 */
.dashboard-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 15px;
	padding: 0 10px;
	flex-shrink: 0;
}

/* 返回按钮样式 */
.back-button {
	background: rgba(24, 144, 255, 0.2) !important;
	border-color: #1890ff !important;
	color: #1890ff !important;
	border-radius: 8px;
	font-size: 14px;
	padding: 6px 12px;
	transition: all 0.3s ease;
}

.back-button:hover {
	background: rgba(24, 144, 255, 0.4) !important;
	transform: translateY(-1px);
	box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.dashboard-header h1 {
	color: #1890ff;
	font-size: 24px;
	font-weight: bold;
	text-shadow: 0 0 10px rgba(24, 144, 255, 0.5);
}

.current-time {
	color: #fff;
	font-size: 14px;
	background: rgba(24, 144, 255, 0.1);
	padding: 6px 12px;
	border-radius: 15px;
	border: 1px solid rgba(24, 144, 255, 0.3);
}

/* 项目基本信息 */
.project-info {
	background: rgba(0, 30, 60, 0.8);
	border: 1px solid rgba(24, 144, 255, 0.3);
	border-radius: 8px;
	padding: 10px 15px;
	margin-bottom: 15px;
	display: flex;
	gap: 20px;
	flex-wrap: wrap;
	flex-shrink: 0;
}

.info-item {
	display: flex;
	align-items: center;
	gap: 5px;
}

.info-label {
	color: #87ceeb;
	font-size: 12px;
}

.info-value {
	color: #fff;
	font-size: 12px;
}

/* 外边框跑马灯效果 - 完整四边动画 */
.border-glow {
	position: relative;
	overflow: hidden;
}

/* 流光动画关键帧 - 水平 */
@keyframes border-glow-horizontal {
	0% {
		transform: translateX(-100%);
	}

	100% {
		transform: translateX(200%);
	}
}

/* 流光动画关键帧 - 垂直 */
@keyframes border-glow-vertical {
	0% {
		transform: translateY(-100%);
	}

	100% {
		transform: translateY(200%);
	}
}

/* 边框流光效果 */
.border-glow {
	position: relative;
	overflow: hidden;
}

/* 顶部边框流光 */
.border-glow::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 2px;
	background: linear-gradient(90deg, transparent, rgba(24, 144, 255, 0.8), transparent);
	animation: border-glow-horizontal 2s infinite linear;
	z-index: 2;
	pointer-events: none;
	will-change: transform;
}

/* 右侧边框流光 */
.border-glow::after {
	content: '';
	position: absolute;
	right: 0;
	top: 0;
	height: 100%;
	width: 2px;
	background: linear-gradient(180deg, transparent, rgba(24, 144, 255, 0.8), transparent);
	animation: border-glow-vertical 2s infinite linear 0.5s;
	z-index: 2;
	pointer-events: none;
	will-change: transform;
}

/* 底部边框流光 */
.border-glow {
	box-shadow: inset 0 -2px 0 0 transparent;
}

/* 左侧边框流光 */
.border-glow {
	box-shadow: inset 0 0 0 2px transparent;
}

/* 板块间接力动画延迟类 */
.delay-0 {
	animation-delay: 0s !important;
}

.delay-1 {
	animation-delay: 0.3s !important;
}

.delay-2 {
	animation-delay: 0.6s !important;
}

.delay-3 {
	animation-delay: 0.9s !important;
}

.delay-4 {
	animation-delay: 1.2s !important;
}

.delay-5 {
	animation-delay: 1.5s !important;
}

/* 内容区域 - 使用 Grid 布局 */
.dashboard-content {
	flex: 1;
	display: grid;
	grid-template-columns: 300px 1fr 300px;
	grid-template-rows: 1fr 250px;
	gap: 15px;
	overflow: hidden;
	grid-template-areas:
		"left center right"
		"bottom bottom bottom";
}

/* 左侧：数据分析 */
.data-analysis {
	grid-area: left;
	background: rgba(0, 30, 60, 0.8);
	border: 1px solid rgba(24, 144, 255, 0.3);
	border-radius: 8px;
	padding: 15px;
	overflow-y: auto;
}

/* 中间：3D可视化区域 */
.three-dimensional {
	grid-area: center;
	background: rgba(0, 30, 60, 0.8);
	border: 1px solid rgba(24, 144, 255, 0.3);
	border-radius: 8px;
	position: relative;
}

/* 右侧：运营数据 */
.operation-data {
	grid-area: right;
	background: rgba(0, 30, 60, 0.8);
	border: 1px solid rgba(24, 144, 255, 0.3);
	border-radius: 8px;
	padding: 15px;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	gap: 15px;
}

/* 底部：核心数据 */
.core-data {
	grid-area: bottom;
	background: rgba(0, 30, 60, 0.8);
	border: 1px solid rgba(24, 144, 255, 0.3);
	border-radius: 8px;
	padding: 15px;
	display: flex;
	gap: 15px;
	overflow-x: auto;
}

/* 模块标题 */
.module-title {
	color: #1890ff;
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 15px;
	display: flex;
	align-items: center;
	gap: 5px;
	border-bottom: 1px solid rgba(24, 144, 255, 0.3);
	padding-bottom: 8px;
}

.more {
	margin-left: auto;
	font-size: 12px;
	color: #87ceeb;
	cursor: pointer;
}

/* 数据分析卡片 */
.analysis-cards {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 20px;
}

.analysis-card {
	background: rgba(24, 144, 255, 0.1);
	border-radius: 8px;
	padding: 12px;
	text-align: center;
	border: 1px solid rgba(24, 144, 255, 0.2);
}

.analysis-value {
	color: #00ffff;
	font-size: 24px;
	font-weight: bold;
	margin-bottom: 5px;
}

.analysis-label {
	color: #87ceeb;
	font-size: 12px;
	margin-bottom: 3px;
}

.analysis-total {
	color: #fff;
	font-size: 10px;
}

/* 部分标题 */
.section-title {
	color: #1890ff;
	font-size: 14px;
	font-weight: bold;
	margin-bottom: 10px;
}

/* 用户分析 */
.user-analysis {
	margin-top: 20px;
}

.user-stats {
	display: flex;
	gap: 10px;
	margin-bottom: 15px;
}

.stat-item {
	background: rgba(24, 144, 255, 0.1);
	border-radius: 6px;
	padding: 8px 12px;
	text-align: center;
	flex: 1;
	border: 1px solid rgba(24, 144, 255, 0.2);
}

.stat-value {
	display: block;
	color: #00ffff;
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 2px;
}

.stat-label {
	display: block;
	color: #87ceeb;
	font-size: 10px;
}

/* 用户列表 */
.user-list,
.user-rank {
	background: rgba(0, 30, 60, 0.8);
	border: 1px solid rgba(24, 144, 255, 0.3);
	border-radius: 6px;
	padding: 10px;
	margin-bottom: 15px;
}

.list-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
	color: #1890ff;
	font-size: 12px;
	font-weight: bold;
}

.user-item,
.rank-item,
.receipt-item,
.type-item,
.device-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 0;
	border-bottom: 1px solid rgba(24, 144, 255, 0.2);
	font-size: 12px;
}

.user-item:last-child,
.rank-item:last-child,
.receipt-item:last-child,
.type-item:last-child,
.device-item:last-child {
	border-bottom: none;
}

.user-info,
.rank-info {
	display: flex;
	align-items: center;
	gap: 5px;
}

.user-name,
.rank-name,
.receipt-name,
.type-name,
.device-name {
	color: #fff;
}

.user-room,
.user-time,
.rank-level,
.rank-value,
.receipt-room,
.receipt-amount,
.receipt-time,
.type-value,
.device-total,
.device-normal,
.device-alarm {
	color: #87ceeb;
}

.rank-number {
	color: #1890ff;
	font-weight: bold;
	margin-right: 10px;
	width: 20px;
	text-align: center;
}

/* 3D容器 */
.three-container {
	width: 100%;
	height: 100%;
}

/* 建筑信息 */
.building-info {
	position: absolute;
	top: 10px;
	right: 10px;
	background: rgba(0, 30, 60, 0.8);
	border: 1px solid rgba(24, 144, 255, 0.3);
	border-radius: 6px;
	padding: 10px;
	width: 200px;
}

.building-info h3 {
	color: #1890ff;
	font-size: 14px;
	font-weight: bold;
	margin-bottom: 8px;
}

.building-stats .stat-item {
	margin-bottom: 5px;
	border: none;
	background: transparent;
	padding: 4px 0;
	text-align: left;
}

.building-stats .stat-value {
	font-size: 12px;
	display: inline;
	margin-left: 5px;
}

/* 运营卡片 */
.operation-card {
	background: rgba(0, 30, 60, 0.8);
	border: 1px solid rgba(24, 144, 255, 0.3);
	border-radius: 8px;
	padding: 10px;
}

/* 入住管理图表 */
#occupancyChart {
	height: 150px;
}

/* 资产数据 */
.assets-data {
	background: rgba(0, 30, 60, 0.8);
	border: 1px solid rgba(24, 144, 255, 0.3);
	border-radius: 8px;
	padding: 10px;
	flex: 1;
	overflow-y: auto;
}

.asset-item {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 10px;
	padding: 8px;
	background: rgba(24, 144, 255, 0.1);
	border-radius: 6px;
	border: 1px solid rgba(24, 144, 255, 0.2);
}

.asset-item i {
	color: #1890ff;
	font-size: 16px;
}

.asset-label {
	color: #87ceeb;
	font-size: 12px;
	flex: 1;
}

.asset-value {
	color: #00ffff;
	font-weight: bold;
	font-size: 14px;
}

/* 核心数据卡片 */
.core-card {
	background: rgba(0, 30, 60, 0.8);
	border: 1px solid rgba(24, 144, 255, 0.3);
	border-radius: 8px;
	padding: 12px;
	flex: 1;
	min-width: 300px;
}

/* 资产统计 */
.asset-stats {
	display: flex;
	gap: 15px;
	margin-bottom: 15px;
}

/* 资产详情 */
.asset-details {
	margin-bottom: 15px;
}

.detail-item {
	margin-bottom: 10px;
}

.detail-label {
	display: block;
	color: #87ceeb;
	font-size: 12px;
	margin-bottom: 3px;
}

.detail-bar {
	height: 6px;
	background: rgba(24, 144, 255, 0.2);
	border-radius: 3px;
	overflow: hidden;
}

.bar-fill {
	height: 100%;
	background: linear-gradient(90deg, #1890ff 0%, #00ffff 100%);
	border-radius: 3px;
	transition: width 0.5s ease;
}

/* 智能设备 */
.smart-devices {
	margin-top: 15px;
}

/* 合同管理 */
.contract-stats {
	display: flex;
	gap: 15px;
	justify-content: space-around;
}

.contract-item {
	text-align: center;
}

.contract-icon {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	margin: 0 auto 5px;
	position: relative;
}

.contract-icon.pending {
	background: rgba(255, 170, 0, 0.3);
	border: 2px solid #ffa500;
}

.contract-icon.processing {
	background: rgba(24, 144, 255, 0.3);
	border: 2px solid #1890ff;
}

.contract-icon.due {
	background: rgba(82, 196, 26, 0.3);
	border: 2px solid #52c41a;
}

.contract-icon.expired {
	background: rgba(245, 34, 45, 0.3);
	border: 2px solid #f5222d;
}

.contract-label {
	display: block;
	color: #87ceeb;
	font-size: 10px;
	margin-bottom: 2px;
}

.contract-value {
	display: block;
	color: #00ffff;
	font-size: 16px;
	font-weight: bold;
}

/* 财务管理 */
.finance-types {
	margin-bottom: 15px;
}

.type-item {
	justify-content: space-between;
	border-bottom: 1px solid rgba(24, 144, 255, 0.2);
	padding: 8px 5px;
}

.type-item:first-child {
	background: rgba(24, 144, 255, 0.1);
	border-bottom: 2px solid rgba(24, 144, 255, 0.3);
	font-weight: bold;
	color: #1890ff;
}

.type-name {
	flex: 1;
}

.type-value {
	flex: 1;
	text-align: right;
}

/* 应收明细 */
.finance-receipts {
	margin-top: 15px;
}

.receipt-item {
	justify-content: space-between;
}

/* 滚动条样式 */
::-webkit-scrollbar {
	width: 6px;
	height: 6px;
}

::-webkit-scrollbar-track {
	background: rgba(0, 30, 60, 0.5);
	border-radius: 3px;
}

::-webkit-scrollbar-thumb {
	background: rgba(24, 144, 255, 0.5);
	border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
	background: rgba(24, 144, 255, 0.7);
}

/* 图表容器 */
.chart-container {
	width: 100%;
	height: 150px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
	.dashboard-content {
		grid-template-columns: 1fr;
		grid-template-rows: auto auto auto auto;
		grid-template-areas:
			"left"
			"center"
			"right"
			"bottom";
	}

	.core-data {
		flex-direction: column;
		overflow-y: auto;
	}

	.core-card {
		min-width: auto;
		margin-bottom: 15px;
	}
}
</style>